const actions = {
    GET_MSISDN_POOL_DATA: 'GET_MSISDN_POOL_DATA',
    GET_MSISDN_POOL_DATA_SUCCESS: 'GET_MSISDN_POOL_DATA_SUCCESS',
    GET_MSISDN_POOL_DATA_FAILED: 'GET_MSISDN_POOL_DATA_FAILED',

    GET_SHORT_CODE_DATA: 'GET_SHORT_CODE_DATA',
    GET_SHORT_CODE_DATA_SUCCESS: 'GET_SHORT_CODE_DATA_SUCCESS',
    GET_SHORT_CODE__DATA_FAILED: "GET_SHORT_CODE__DATA_FAILED",

    RESET_SEARCH_DATA: "RESET_SEARCH_DATA",

    PREPARE_MSISDN_FORM: "PREPARE_MSISDN_FORM",

    RESET_MSISDN: "RESET_MSISDN",

    REMOVE_MSISDN_FROM_POOL: "REMOVE_MSISDN_FROM_POOL",
    REMOVE_MSISDN_FROM_POOL_SUCCESS: "REMOVE_MSISDN_FROM_POOL_SUCCESS",
    REMOVE_MSISDN_FROM_POOL_FAILED: "REMOVE_MSISDN_FROM_POOL_FAILED",

    getMsisdnPool: (data) => ({
        type: actions.GET_MSISDN_POOL_DATA,
        payload: { data }
    }),
    getMsisdnPoolSuccess: (result) => ({
        type: actions.GET_MSISDN_POOL_DATA_SUCCESS,
        result
    }),
    getMsisdnPoolFailed: (error) => ({
        type: actions.GET_MSISDN_POOL_DATA_FAILED,
        error
    }),

    resetSearchData: () => ({
        type: actions.RESET_SEARCH_DATA,
    }),

    getShortCodeData: (data) => ({
        type: actions.GET_SHORT_CODE_DATA,
        payload: { data }
    }),
    getShortCodeDataSuccess: (shortCodeData) => ({
        type: actions.GET_SHORT_CODE_DATA_SUCCESS,
        shortCodeData
    }),
    getShortCodeDataFailed: (error) => ({
        type: actions.GET_SHORT_CODE__DATA_FAILED,
        error
    }),

    prepareMsidnForm: () => ({
        type: actions.PREPARE_MSISDN_FORM
    }),

    resetMsisdn: () => ({
        type: actions.RESET_MSISDN
    }),

    removeMsisdnFromPool: (data, searchData) => ({
        type: actions.REMOVE_MSISDN_FROM_POOL,
        payload: { data, searchData }
    }),
    removeMsisdnFromPoolSuccess: (message) => ({
        type: actions.REMOVE_MSISDN_FROM_POOL_SUCCESS,
        message
    }),
    removeMsisdnFromPoolFailed: (error) => ({
        type: actions.REMOVE_MSISDN_FROM_POOL_FAILED,
        error
    }),

};
export default actions;
